import { render, staticRenderFns } from "./ThePrimaryToolbar.vue?vue&type=template&id=0dd7a6b8&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ThePrimaryToolbar.vue"
export default component.exports